(function (scope) {
  function evaluate(data, input) {
    const transport = input.transport;
    const gear = input.gear;
    const skis = gear === 'boards' ? 0 : Number(input.skis);
    const boards = gear === 'skis' ? 0 : Number(input.boards);
    const spaces = skis + 2 * boards;
    const base = { skis, boards, spaces, choices: [] };
    if (!['roof', 'car', 'pickup'].includes(transport) || !['skis', 'boards', 'mixed'].includes(gear) ||
        !Number.isInteger(skis) || skis < 0 || skis > 10 ||
        !Number.isInteger(boards) || boards < 0 || boards > 4) return { ...base, status: 'invalid' };
    if (!spaces) return { ...base, status: 'empty' };
    if (transport === 'car' && boards) return { ...base, status: 'car_board_check' };
    let candidates = data.catalog.filter(p => p.transport === transport);
    let status = 'capacity_match';
    if (transport === 'roof') {
      const rows = data.records.filter(r => r.brand === input.brand && r.model === input.model);
      if (!rows.length) return { ...base, status: 'matrix_needed' };
      candidates = candidates.filter(p => rows.every(r => r.fits[p.column] === true) &&
        (gear === 'boards'
          ? p.kind === 'boards' && p.boards >= boards
          : p.kind === 'skis' && p.pairs >= spaces &&
            (p.skiType === 'any' || p.skiType === input.skiType)));
      status = 'matrix_match';
    } else if (transport === 'car') {
      candidates = candidates.filter(p => p.pairs === skis && p.skiType === input.skiType);
    } else {
      candidates = candidates.filter(p => p.pairs >= spaces);
    }
    candidates.sort((a, b) => (a.pairs || a.boards * 2) - (b.pairs || b.boards * 2));
    return { ...base, status: candidates.length ? status : 'none', choices: candidates };
  }
  const api = { evaluate };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else scope.CactusFit = api;
})(typeof window === 'undefined' ? {} : window);
